import React from 'react';
import {ErrorModal} from '@igp/shared/components/error';
import {withTraceErrorBoundary} from '@igp/shared/otel';

import {CountryLevelPartnerReportBase} from './CountryLevelPartnerReportBase';

function DepositActivityOverviewInner() {
    return <CountryLevelPartnerReportBase tabId="DepositActivityOverview" />;
}

export const DepositActivityOverview = withTraceErrorBoundary(DepositActivityOverviewInner, ErrorModal);
